import React, { useEffect } from "react";
import { ManageStockBasePage } from "../..";
import { useRenaveContext } from "../../../../hooks";
import { RenaveMenuStepsEnum } from "../../../../models";
import { CheckOutDanfeOrganism } from "../../../organisms";

export const CheckOutDanfePage: React.FC = () => {
  const {
    menuCurrentStepContext,
    menuSelectedStepContext,
    setMenuSelectedStepContext,
  } = useRenaveContext();

  useEffect(() => {
    setMenuSelectedStepContext(RenaveMenuStepsEnum.CheckOutDanfe);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ManageStockBasePage>
      <CheckOutDanfeOrganism
        viewMode={menuSelectedStepContext < menuCurrentStepContext}
      />
    </ManageStockBasePage>
  );
};
